export default __webpack_public_path__ + "568df88271b5360695a4cbd5d8b904ed.png";